import React, { Component } from 'react';
import NavMenu from './nav-menu/nav-menu.component';
import { Footer } from '../common/footer/footer.component';
class InternalLayout extends Component {

    render() {
        return (
            <>
                <div>
                    {!window.location.pathname.toLowerCase().includes("login") ? <NavMenu /> : ""}
                    <div className="main-wrapper">
                        {this.props.children}
                    </div>
                    {!window.location.pathname.toLowerCase().includes("login") ? <Footer /> : ""}
                </div>

            </>
        )
    }

}

export default InternalLayout;
